import polygon from '../../icons/polygon.svg';
import bsc from '../../icons/bsc.svg';
import ftm from '../../icons/ftm.svg';
import eth from '../../icons/eth.svg';
import manta from '../../icons/manta.svg';
import blast from '../../icons/blast.svg';
import mode from '../../icons/mode.svg';
import base from '../../icons/base.svg';
import React, { useState, useEffect } from 'react';
import { Field, Form, Formik } from 'formik';

interface Step2Props {
  response: any;
  setResponse: (response: any) => void;
  onNextClick: () => void;
  onPrevlick?: () => void;
}

const Step2: React.FC<Step2Props> = ({
  response,
  setResponse,
  onNextClick,
  onPrevlick,
}) => {
  const [fillTS, setFillTS] = useState(false);
  const [fillNFT, setFillNFT] = useState(false);
  const [fillFtm, setFillFtm] = useState(false);
  const [fillBsc, setFillBsc] = useState(false);
  const [fillPol, setFillPol] = useState(false);

  const [requiresNftAuthentication, setRequiresNftAuthentication] =
    useState(false);
  const [saleVersion, setSellVersion] = useState('fcfs');

  const [isKYCChecked, setIsKYCChecked] = useState(false);
  const [isStakeChecked, setIsStakeChecked] = useState(false);

  const handleToggleKYC = (e: any) => {
    e.preventDefault();
    setInputVal((prevInputVal: any) => ({
      ...prevInputVal,
      with_kyc: !isKYCChecked,
    }));
    setIsKYCChecked(!isKYCChecked);
  };

  const handleToggleStake = (e: any) => {
    e.preventDefault();
    setInputVal((prevInputVal: any) => ({
      ...prevInputVal,
      only_staked: !isStakeChecked,
    }));
    setIsStakeChecked(!isStakeChecked);
  };

  const [inputVal, setInputVal] = useState<any>({
    name: response.name,
    description: response.description,
    tags: '',
    chain: response.chain ? response.chain : 0,
    logo_image_url: response.logo_image_url ? response.logo_image_url : '',
    main_image_url: response.main_image_url ? response.main_image_url : '',
    start_date_whitelist: response.start_date_whitelist
      ? response.start_date_whitelist
      : null,
    end_date_whitelist: response.end_date_whitelist
      ? response.end_date_whitelist
      : null,
    start_date_funding: response.start_date_funding
      ? response.start_date_funding
      : null,
    end_date_funding: response.end_date_funding
      ? response.end_date_funding
      : null,
    ido_token_symbol: response.ido_token_symbol
      ? response.ido_token_symbol
      : '',
    pay_token_symbol: response.pay_token_symbol
      ? response.pay_token_symbol
      : 'axlUDSC',
    ratio: null,
    sale_version: response.sale_version ? response.sale_version : 0,
    with_whitelist: false,
    with_lottery: false,
    only_staked: false,
    with_kyc: false,
  });

  const handleClick = (propval: String) => {
    if (propval === 'token') {
      setFillTS(true);
      setFillNFT(false);
      setInputVal((prevInputVal: any) => ({
        ...prevInputVal,
        sale_version: requiresNftAuthentication ? 6 : 4,
      }));
    } else {
      setFillNFT(true);
      setFillTS(false);
      setInputVal((prevInputVal: any) => ({
        ...prevInputVal,
        sale_version: requiresNftAuthentication ? 5 : 3,
      }));
    }
  };

  const handleNextClick = () => {
    setResponse(inputVal);
    onNextClick();
  };

  const handlePrevClick = () => {
    setResponse(inputVal);
    if (typeof onPrevlick === 'function') {
      onPrevlick();
    }
  };
  const handleSubmit = () => {
    setResponse(inputVal);
  };

  const handleToggleNftAuthentication = (e: any) => {
    e.preventDefault();
    if (inputVal.sale_version) {
      setInputVal((prevInputVal: any) => ({
        ...prevInputVal,
        sale_version: inputVal.sale_version + 2,
      }));
    }
    setRequiresNftAuthentication(!requiresNftAuthentication);
  };

  return (
    <div className="overflow-x-hidden overflow-y-hidden sm:overflow-visible w-full sm:w-fit px-5 sm:px-0">
      <div
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.03)',
          borderColor: 'rgba(255, 255, 255, 0.03)',
        }}
        className="mt-[50px]  w-full  p-[20px] rounded-[30px] border-[2px]  sm:mt-[40px]  sm:w-[490px]   sm:py-[45px] sm:px-[42px] sm:rounded-[30px] sm:border-[2px] flex-col justify-start items-start gap-[30px] inline-flex"
      >
        <div className=" justify-start items-start inline-flex">
          <p className="text-[24px] leading-[64px]  font-[700]   text-transparent bg-clip-text bg-gradient-to-r from-[#987EF5] to-[#F19571] opacity-100 sm:text-[40px] sm:leading-[64px]  sm:font-[700] sm:w-[500px]  sm:text-transparent sm:bg-clip-text sm:bg-gradient-to-r sm:from-[#987EF5] sm:to-[#F19571] sm:opacity-100">
            Token sale information
          </p>
        </div>

        <div className="flex-col justify-start items-start gap-2.5 flex w-full">
          <p className="text-[20px]  text-[#A68DFF] font-[600]  sm:text-[20px] sm:text-[#A68DFF] sm:font-[600] ">
            What are you planning to sale?
          </p>

          <div className="flex gap-10 sm:gap-[33px] w-full">
            <button
              onClick={() => handleClick('token')}
              className="relative bg-black px-4 py-2 w-[138px] sm:w-[185px] rounded-[20px] h-[106px] text-white z-10 border-[1px] border-transparent hover:border-purple-500"
            >
              <p className="absolute bottom-3 left-3 text-[14px] font-[600]">
                Tokens
              </p>
              <svg
                className={`absolute top-5 left-5 ${
                  fillTS === true ? 'fill-[#B36CFF]' : 'fill-none'
                }`}
                width="28"
                height="28"
                viewBox="0 0 28 28"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.2453 14.2304L10.2427 14.2289C10.0223 14.0963 9.72143 14.2286 9.67648 14.4893C9.66925 14.5318 9.67039 14.5996 9.69118 14.6717C9.71216 14.7445 9.74084 14.7803 9.74824 14.7877L9.75804 14.7974L9.76757 14.8075C10.216 15.2809 10.7762 15.7688 11.3726 16.287L10.2453 14.2304ZM10.2453 14.2304C10.2616 14.2402 10.2788 14.2525 10.2959 14.2676C10.6849 14.6402 11.1166 15.0244 11.528 15.3906L11.5329 15.395L11.5359 15.3977L11.8925 15.7176L12.6147 16.3657M10.2453 14.2304L12.6147 16.3657M12.6147 16.3657L13.2842 15.6633M12.6147 16.3657L13.2842 15.6633M13.2842 15.6633L17.5493 11.1892C17.5494 11.1891 17.5495 11.189 17.5496 11.1889C17.5497 11.1888 17.5497 11.1888 17.5498 11.1887C17.6763 11.0561 17.7248 11.0141 17.7583 10.9909L17.7584 10.9909C17.7725 10.9811 17.7944 10.966 17.8664 10.9497C17.969 10.9274 18.0414 10.9435 18.0973 10.9708C18.1611 11.0019 18.2248 11.0592 18.2704 11.139C18.316 11.2188 18.3319 11.3007 18.3263 11.368C18.3214 11.4264 18.2994 11.4958 18.2258 11.5736C18.2256 11.5738 18.2254 11.574 18.2252 11.5742L12.9099 17.1516L12.9099 17.1516M13.2842 15.6633L12.9099 17.1516M12.9099 17.1516L12.9042 17.1576M12.9099 17.1516L12.9042 17.1576M12.9042 17.1576C12.8474 17.2182 12.7525 17.2656 12.6378 17.2705C12.5252 17.2754 12.4399 17.2379 12.3882 17.1888L12.3882 17.1888M12.9042 17.1576L12.3882 17.1888M12.3882 17.1888L12.3799 17.1811M12.3882 17.1888L12.3799 17.1811M12.3799 17.1811C12.0573 16.8819 11.7097 16.5798 11.3727 16.2871L12.3799 17.1811ZM27 14.0001C27 6.82042 21.1796 1 14 1C6.82016 1 1 6.82043 1 14.0001C1 21.1798 6.82016 27.0002 14 27C21.1796 27 27 21.1798 27 14.0001Z"
                  stroke={`${fillTS === true ? 'black' : 'white'}`}
                  stroke-opacity={`${fillTS === true ? '3' : '0.2'}`}
                  stroke-width="2"
                />
              </svg>
              <svg
                className="absolute right-0 bottom-1  w-[50px] h-[50px] sm:absolute sm:right-1 sm:bottom-2"
                width="68"
                height="68"
                viewBox="0 0 68 68"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_iii_149_110)">
                  <path
                    d="M62.3334 24.0834C62.3334 33.32 55.5333 40.9417 46.6933 42.2734V42.1034C45.815 31.11 36.89 22.185 25.8117 21.3067H25.7267C27.0584 12.4667 34.68 5.66669 43.9167 5.66669C54.0884 5.66669 62.3334 13.9117 62.3334 24.0834Z"
                    fill="url(#paint0_linear_149_110)"
                  />
                </g>
                <g filter="url(#filter1_iii_149_110)">
                  <path
                    d="M42.4434 42.4433C41.735 33.4617 34.5384 26.265 25.5567 25.5567C25.075 25.5283 24.565 25.5 24.0834 25.5C13.9117 25.5 5.66669 33.745 5.66669 43.9167C5.66669 54.0883 13.9117 62.3333 24.0834 62.3333C34.255 62.3333 42.5 54.0883 42.5 43.9167C42.5 43.435 42.4717 42.925 42.4434 42.4433ZM26.5767 46.41L24.0834 51L21.59 46.41L17 43.9167L21.59 41.4233L24.0834 36.8333L26.5767 41.4233L31.1667 43.9167L26.5767 46.41Z"
                    fill="url(#paint1_linear_149_110)"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_iii_149_110"
                    x="24.7267"
                    y="5.66669"
                    width="39.6067"
                    height="40.6067"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      result="shape"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="3" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.665042 0 0 0 0 0.524198 0 0 0 0 0.9875 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="shape"
                      result="effect1_innerShadow_149_110"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="-1" dy="2" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 0.7125 0 0 0 0 0.749597 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="effect1_innerShadow_149_110"
                      result="effect2_innerShadow_149_110"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="effect2_innerShadow_149_110"
                      result="effect3_innerShadow_149_110"
                    />
                  </filter>
                  <filter
                    id="filter1_iii_149_110"
                    x="4.66669"
                    y="25.5"
                    width="39.8333"
                    height="40.8333"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      result="shape"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="3" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.665042 0 0 0 0 0.524198 0 0 0 0 0.9875 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="shape"
                      result="effect1_innerShadow_149_110"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="-1" dy="2" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 0.7125 0 0 0 0 0.749597 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="effect1_innerShadow_149_110"
                      result="effect2_innerShadow_149_110"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="effect2_innerShadow_149_110"
                      result="effect3_innerShadow_149_110"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_149_110"
                    x1="62.1266"
                    y1="27.8448"
                    x2="25.9336"
                    y2="27.9195"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#F7AD74" />
                    <stop offset="1" stop-color="#7A5AFC" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_149_110"
                    x1="42.292"
                    y1="47.8154"
                    x2="5.87492"
                    y2="47.8906"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#F7AD74" />
                    <stop offset="1" stop-color="#7A5AFC" />
                  </linearGradient>
                </defs>
              </svg>
            </button>
            <button
              onClick={() => handleClick('nft')}
              className="relative bg-black px-4 py-2 w-[138px] sm:w-[185px] rounded-[20px] h-[106px] text-white z-10 border-[1px] border-transparent hover:border-purple-500"
            >
              <p className="absolute bottom-3 left-3 text-[14px] font-[600]">
                NFTs
              </p>
              <svg
                className={`absolute top-5 left-5 ${
                  fillNFT === true ? 'fill-[#B36CFF]' : 'fill-none'
                }`}
                width="28"
                height="28"
                viewBox="0 0 28 28"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.2453 14.2304L10.2427 14.2289C10.0223 14.0963 9.72143 14.2286 9.67648 14.4893C9.66925 14.5318 9.67039 14.5996 9.69118 14.6717C9.71216 14.7445 9.74084 14.7803 9.74824 14.7877L9.75804 14.7974L9.76757 14.8075C10.216 15.2809 10.7762 15.7688 11.3726 16.287L10.2453 14.2304ZM10.2453 14.2304C10.2616 14.2402 10.2788 14.2525 10.2959 14.2676C10.6849 14.6402 11.1166 15.0244 11.528 15.3906L11.5329 15.395L11.5359 15.3977L11.8925 15.7176L12.6147 16.3657M10.2453 14.2304L12.6147 16.3657M12.6147 16.3657L13.2842 15.6633M12.6147 16.3657L13.2842 15.6633M13.2842 15.6633L17.5493 11.1892C17.5494 11.1891 17.5495 11.189 17.5496 11.1889C17.5497 11.1888 17.5497 11.1888 17.5498 11.1887C17.6763 11.0561 17.7248 11.0141 17.7583 10.9909L17.7584 10.9909C17.7725 10.9811 17.7944 10.966 17.8664 10.9497C17.969 10.9274 18.0414 10.9435 18.0973 10.9708C18.1611 11.0019 18.2248 11.0592 18.2704 11.139C18.316 11.2188 18.3319 11.3007 18.3263 11.368C18.3214 11.4264 18.2994 11.4958 18.2258 11.5736C18.2256 11.5738 18.2254 11.574 18.2252 11.5742L12.9099 17.1516L12.9099 17.1516M13.2842 15.6633L12.9099 17.1516M12.9099 17.1516L12.9042 17.1576M12.9099 17.1516L12.9042 17.1576M12.9042 17.1576C12.8474 17.2182 12.7525 17.2656 12.6378 17.2705C12.5252 17.2754 12.4399 17.2379 12.3882 17.1888L12.3882 17.1888M12.9042 17.1576L12.3882 17.1888M12.3882 17.1888L12.3799 17.1811M12.3882 17.1888L12.3799 17.1811M12.3799 17.1811C12.0573 16.8819 11.7097 16.5798 11.3727 16.2871L12.3799 17.1811ZM27 14.0001C27 6.82042 21.1796 1 14 1C6.82016 1 1 6.82043 1 14.0001C1 21.1798 6.82016 27.0002 14 27C21.1796 27 27 21.1798 27 14.0001Z"
                  stroke={`${fillNFT === true ? 'black' : 'white'}`}
                  stroke-opacity={`${fillNFT === true ? '3' : '0.2'}`}
                  stroke-width="2"
                />
              </svg>
              <svg
                className="absolute right-1 bottom-1 w-[60px] h-[50px] sm:absolute sm:right-1 sm:bottom-2"
                width="87"
                height="88"
                viewBox="0 0 87 88"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_iii_65_1245)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 90.8017V89.0842C0 71.9625 9.25664 70.7129 18.6152 69.4509C25.4426 68.5293 32.3314 67.5987 34.7643 59.2275L34.6307 59.1088C34.2932 58.8057 33.8678 58.4353 33.4494 58.0737L33.3809 58.0099C30.3047 55.337 27.7471 53.0772 27.2865 47.5756C25.7273 47.4143 24.3404 46.2498 23.3648 44.69C22.5738 43.4227 22.0447 41.8754 21.9445 40.4433C21.9059 39.9133 21.9252 39.394 22.0078 38.9013H20.9092C20.5014 38.9013 20.1674 38.5645 20.1674 38.1533V33.9402C20.1674 33.4829 20.5383 33.1107 20.99 33.1107H22.3787V31.0104C22.3787 30.0728 22.7584 29.2202 23.3701 28.6034C23.683 28.2879 24.0539 28.0345 24.4688 27.8625C24.2842 22.8749 23.5354 17.7579 19.2428 16.4481C31.2047 1.54187 44.993 -6.56347 55.3465 6.69611C65.25 7.22075 70.4408 19.922 67.1836 29.3461C67.4631 29.8406 67.6213 30.4077 67.6213 31.0104V33.1107H69.01C69.4617 33.1107 69.8326 33.4829 69.8326 33.9402V38.1533C69.8326 38.5645 69.4986 38.9013 69.0908 38.9013H67.6213V39.7343C67.6213 40.422 67.5246 41.0867 67.3453 41.7159C67.1221 43.031 66.6387 44.371 65.9549 45.4132C65.0215 46.8364 63.7594 47.767 62.2723 47.6252C62.1897 52.6164 59.785 54.9063 56.6314 57.8929C59.1275 66.296 65.8107 67.6005 72.3779 68.882C81.2848 70.619 90 72.317 90 88.7031V90.8017C90 91.4628 89.4674 91.9999 88.8117 91.9999H1.18828C0.532617 91.9999 0 91.4628 0 90.8017ZM27.1617 32.0207H29.9514C30.5455 32.0207 31.0307 32.5081 31.0307 33.1089V35.8456C31.0307 36.4447 30.5455 36.9321 29.9514 36.9321H27.1617C26.5676 36.9321 26.0824 36.4447 26.0824 35.8456V33.1089C26.0824 32.5081 26.5676 32.0207 27.1617 32.0207ZM25.7572 29.3939C24.8766 29.3939 24.1559 30.1242 24.1559 31.0104V39.7343C24.1559 42.7067 26.5676 45.142 29.5172 45.142H38.4311C41.7814 45.142 43.4232 40.539 44.9209 40.539C46.5926 40.539 48.0814 45.142 51.5689 45.142H60.4828C63.4307 45.142 65.8441 42.7084 65.8441 39.7343V31.0104C65.8441 30.1224 65.1234 29.3939 64.241 29.3939H25.7572ZM32.7023 27.6038H60.3879C60.1471 26.3684 59.7938 25.2996 59.3525 24.3691C58.1344 21.8079 56.192 20.257 54.0861 19.0978C49.4139 22.7083 46.1232 23.1177 42.8414 23.5272C40.1273 23.8657 37.4186 24.2025 33.8291 26.7069C33.4213 26.9905 33.0451 27.29 32.7023 27.6038ZM59.8887 46.9322H51.5689C48.6967 46.9322 47.0391 44.9789 45.6838 43.382C45.2022 42.813 45.0475 42.3309 44.9209 42.3309C44.7029 42.3309 44.7574 42.7793 44.3039 43.3182C42.9486 44.9258 41.2559 46.9322 38.4311 46.9322H29.6174C29.9197 51.8081 32.1855 53.8163 34.9277 56.1984L34.9998 56.2569C35.3654 56.5724 35.7398 56.8986 36.2109 57.3204C39.1236 59.933 42.1875 61.2836 45.1916 61.2818C48.1131 61.28 51.0363 59.9932 53.7592 57.3434C54.1986 56.9163 54.5994 56.5352 54.9879 56.1683C57.8391 53.4671 59.9836 51.4341 59.8887 46.9322ZM38.6174 51.2179H50.6268C51.7412 51.1736 52.0295 51.7674 51.6551 52.588C48.4436 59.8904 37.865 56.2942 37.7262 52.487C37.7086 51.9269 37.9898 51.2658 38.6174 51.2179ZM42.8361 48.4405C42.6506 48.2817 42.5344 48.0557 42.5127 47.8113C42.5018 47.6896 42.515 47.5669 42.5516 47.4504C42.5881 47.3338 42.6472 47.2258 42.7254 47.1324C42.8035 47.0371 42.8997 46.9586 43.0084 46.9013C43.1171 46.8441 43.236 46.8094 43.3582 46.7992C43.592 46.778 43.8398 46.8471 44.0314 47.0137C44.1686 47.1324 44.3268 47.2157 44.485 47.2778C44.6625 47.3469 44.8418 47.3877 44.9789 47.3877C45.116 47.3877 45.2953 47.354 45.4887 47.2849C45.6451 47.2211 45.8103 47.1324 45.9545 47.0208L45.9897 46.9924C46.1813 46.84 46.4221 46.778 46.6488 46.7992C46.8756 46.8205 47.0953 46.9322 47.2605 47.1183L47.2939 47.159C47.4397 47.3478 47.5088 47.5854 47.4873 47.8237C47.4662 48.0612 47.3502 48.2881 47.1498 48.4547C46.8394 48.71 46.4889 48.9113 46.1127 49.0502C45.7207 49.1956 45.3234 49.2665 44.9666 49.2576C44.608 49.2523 44.2248 49.1761 43.8451 49.036C43.4883 48.8978 43.1455 48.7046 42.8502 48.4476L42.8361 48.4405ZM40.0816 53.8092L39.5402 52.3895H49.9711L49.5018 53.8092H40.0816ZM54.8508 59.7841C51.2121 64.8426 40.6037 64.9525 36.6434 60.9362C35.6555 65.0908 33.0891 67.9603 29.2939 69.8285C40.1766 76.5212 50.9062 76.3227 61.4637 68.4282C57.4014 66.569 55.35 63.6037 54.8508 59.7841Z"
                    fill="url(#paint0_linear_65_1245)"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_iii_65_1245"
                    x="-1"
                    y="0.000366211"
                    width="93"
                    height="95.9995"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="BackgroundImageFix"
                      result="shape"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="3" />
                    <feGaussianBlur stdDeviation="1" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0.665042 0 0 0 0 0.524198 0 0 0 0 0.9875 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="shape"
                      result="effect1_innerShadow_65_1245"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dx="-1" dy="2" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 0.7125 0 0 0 0 0.749597 0 0 0 1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="effect1_innerShadow_65_1245"
                      result="effect2_innerShadow_65_1245"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="effect2_innerShadow_65_1245"
                      result="effect3_innerShadow_65_1245"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_65_1245"
                    x1="89.4918"
                    y1="55.7382"
                    x2="0.50878"
                    y2="55.9177"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#F7AD74" />
                    <stop offset="1" stop-color="#7A5AFC" />
                  </linearGradient>
                </defs>
              </svg>
            </button>
          </div>
        </div>

        <div className="Frame20 self-stretch h-[65px]  flex-col justify-start items-start flex">
          <p className="text-[20px]  text-[#A68DFF] font-[600]  sm:text-[20px] sm:text-[#A68DFF] sm:font-[600] ">
            Investment strategy
          </p>
          <div
            role="group"
            aria-labelledby="my-radio-group"
            className="Frame5735 self-stretch justify-between items-start gap-2.5 inline-flex"
          >
            <div className="Frame5732 justify-start items-center flex">
              <div className="RadioButtons h-12 pl-[1.50px] pr-[9.50px] py-[15px] flex-col justify-center items-center inline-flex">
                <label className="Icon w-[18px] h-[18px] relative flex-col justify-start items-start flex">
                  <input
                    type="radio"
                    name="sale_type"
                    value="fcfs"
                    className="radio border-purple-500 checked:bg-purple-500  w-[18px] h-[18px]"
                    onClick={() => {
                      setSellVersion('fcfs');
                      setInputVal((prevInputVal: any) => ({
                        ...prevInputVal,
                        with_lottery: false,
                        with_whitelist: false,
                      }));
                    }}
                  />
                </label>
              </div>
              <label
                htmlFor="FCFS"
                className="Label text-white text-sm font-normal"
              >
                Open sale
              </label>
            </div>
            <div className="Frame5735 pl-5 justify-start items-center flex">
              <div className="RadioButtons h-12 pl-[1.50px] pr-[9.50px] py-[15px] flex-col justify-center items-center inline-flex">
                <label className="Icon w-[18px] h-[18px] relative flex-col justify-start items-start flex">
                  <input
                    type="radio"
                    name="sale_type"
                    value="whitelist"
                    className="radio  border-purple-500 checked:bg-purple-500  w-[18px] h-[18px] "
                    onClick={() => {
                      setSellVersion('whitelist');
                      setInputVal((prevInputVal: any) => ({
                        ...prevInputVal,
                        with_lottery: false,
                        with_whitelist: true,
                      }));
                    }}
                  />
                </label>
              </div>
              <label
                htmlFor="WHITELIST"
                className="Label text-white text-sm font-normal"
              >
                Registered sale
              </label>
            </div>
            <div className="Frame5736 pl-5 justify-start items-center flex">
              <div className="RadioButtons h-12 pl-[1.50px] pr-[9.50px] py-[15px] flex-col justify-center items-center inline-flex">
                <label className="Icon w-[18px] h-[18px] relative flex-col justify-start items-start flex">
                  <input
                    type="radio"
                    name="sale_type"
                    value="lottery"
                    className="radio border-purple-500 checked:bg-purple-500  w-[18px] h-[18px]  "
                    onClick={() => {
                      setSellVersion('lottery');
                      setInputVal((prevInputVal: any) => ({
                        ...prevInputVal,
                        with_lottery: true,
                        with_whitelist: true,
                      }));
                    }}
                  />
                </label>
              </div>
              <label
                htmlFor="LOTTERY"
                className="Label text-white text-sm font-normal"
              >
                Lottery sale
              </label>
            </div>
          </div>
        </div>

        {saleVersion !== 'fcfs' && (
          <div className="Frame5725 self-stretch justify-between items-center gap-[15px] inline-flex">
            <div className="Card w-[145px] sm:w-[170px] h-[84px] p-3.5 rounded-[10px] border border-neutral-700 flex-col justify-between items-start inline-flex">
              <div className="Frame38 justify-start items-center gap-[5px] inline-flex">
                <div className="Label text-neutral-400 text-sm font-normal">
                  Stake required
                </div>
              </div>
              <div className="relative Frame5724 self-stretch justify-between items-start gap-2.5 inline-flex">
                <div className="Label text-white text-sm font-normal">
                  {isStakeChecked ? 'Yes' : 'No'}
                </div>
                <div
                  className="relative inline-block"
                  onClick={(e) => handleToggleStake(e)}
                >
                  <input
                    type="radio"
                    name="stake_required"
                    value={isStakeChecked ? 'no' : 'yes'}
                    className={`peer pl-[22.35px] pr-[1.35px] py-[1.35px] w-[42px] h-[21px] cursor-pointer appearance-none rounded-full  ${
                      isStakeChecked ? 'bg-purple-500' : 'bg-neutral-700'
                    }  `}
                  />

                  <span
                    className={`pointer-events-none absolute  top-[1.5px] block w-[18.29px] h-[18.29px] rounded-full bg-white transition-all duration-200 ${
                      isStakeChecked
                        ? 'transform translate-x-[22px]'
                        : 'transform translate-x-[0px]'
                    }`}
                  />
                </div>
              </div>
            </div>
            <div className="Card w-[145px] sm:w-[170px] h-[84px] p-3.5 rounded-[10px] border border-neutral-700 flex-col justify-between items-start inline-flex">
              <div className="Frame38 justify-start items-center gap-[5px] inline-flex">
                <div className="Label text-neutral-400 text-sm font-normal">
                  KYC required
                </div>
              </div>
              <div className="relative Frame5724 self-stretch justify-between items-start gap-2.5 inline-flex">
                <div className="Label text-white text-sm font-normal">
                  {isKYCChecked ? 'Yes' : 'No'}
                </div>

                <div
                  className="relative inline-block"
                  onClick={(e) => handleToggleKYC(e)}
                >
                  <input
                    type="radio"
                    name="kyc_required"
                    value={isKYCChecked ? 'no' : 'yes'}
                    className={`peer pl-[22.35px] pr-[1.35px] py-[1.35px] w-[42px] h-[21px] cursor-pointer appearance-none rounded-full  ${
                      isKYCChecked ? 'bg-purple-500' : 'bg-neutral-700'
                    }  `}
                  />
                  <span
                    className={`pointer-events-none absolute  top-[1.5px] block w-[18.29px] h-[18.29px] rounded-full bg-white transition-all duration-200 ${
                      isKYCChecked
                        ? 'transform translate-x-[22px]'
                        : 'transform translate-x-[0px]'
                    }`}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="Card w-full p-3.5 rounded-[10px] border border-neutral-700 flex-row justify-between items-start inline-flex">
          <div className="Frame38 justify-start items-center gap-[5px] inline-flex">
            <div className="Label text-neutral-400 text-sm font-normal">
              Requires NFT Authentication
            </div>
          </div>
          <div className="relative Frame5724 self-stretch justify-between items-start gap-2.5 inline-flex">
            <div className="Label text-white text-sm font-normal">
              {requiresNftAuthentication ? 'Yes' : 'No'}
            </div>
            <div
              className="relative inline-block"
              onClick={(e) => handleToggleNftAuthentication(e)}
            >
              <div
                className={`peer pl-[22.35px] pr-[1.35px] py-[1.35px] w-[42px] h-[21px] cursor-pointer appearance-none rounded-full  ${
                  requiresNftAuthentication ? 'bg-purple-500' : 'bg-neutral-700'
                }  `}
              ></div>
              <span
                className={`pointer-events-none absolute  top-[1.5px] block w-[18.29px] h-[18.29px] rounded-full bg-white transition-all duration-200 ${
                  requiresNftAuthentication
                    ? 'transform translate-x-[22px]'
                    : 'transform translate-x-[0px]'
                }`}
              />
            </div>
          </div>
        </div>

        <div className="flex-col justify-start items-start gap-2.5 flex w-full">
          <p className="text-[20px] text-[#A68DFF] font-[600]   sm:text-[20px] sm:text-[#A68DFF] sm:font-[600]">
            Project blockchain network
          </p>
          <div className="grid grid-cols-2 gap-4 sm:grid  sm:gap-[21px]">
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 4002,
                }));
                setFillFtm(true);
              }}
            >
              <img
                src={ftm}
                className="absolute h-[40px] w-[40px] top-3 left-3"
                alt="fantom-testnet"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Fantom Testnet
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 250,
                }));
                setFillFtm(true);
              }}
            >
              <img
                src={ftm}
                className="absolute h-[40px] w-[40px] top-3 left-3"
                alt="fantom"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Fantom
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 80002,
                }));
                setFillPol(true);
              }}
            >
              <img
                src={polygon}
                className="absolute h-[40px] w-[40px] top-3 left-3"
                alt="Polygon-testnet"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Polygon Testnet
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 137,
                }));
                setFillPol(true);
              }}
            >
              <img
                src={polygon}
                className="absolute h-[40px] w-[40px] top-3 left-3"
                alt="Polygon"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Polygon
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 84532,
                }));
              }}
            >
              <img
                src={base}
                className="absolute h-[40px] w-[40px] top-3 left-3"
                alt="base-testnet"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Base Testnet
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 8453,
                }));
              }}
            >
              <img
                src={base}
                className="absolute h-[40px] w-[40px] top-3 left-3"
                alt="base"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Base
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 168587773,
                }));
                setFillPol(true);
              }}
            >
              <img
                src={blast}
                className="absolute h-[40px] w-[40px] top-3 left-3 rounded-full"
                alt="blast-sepolia"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Blast Sepolia
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 81457,
                }));
                setFillPol(true);
              }}
            >
              <img
                src={blast}
                className="absolute h-[40px] w-[40px] top-3 left-3 rounded-full"
                alt="blast-sepolia"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Blast
              </p>
            </button>
            <button
              className="relative  bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 97,
                }));
                setFillBsc(true);
              }}
            >
              <img
                src={bsc}
                className="absolute h-[40px] w-[40px] top-3 left-3"
                alt="BSC"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                BSC
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 11155111,
                }));
                setFillPol(true);
              }}
            >
              <img
                src={eth}
                className="absolute h-[40px] w-[40px] top-3 left-3"
                alt="Sepolia"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Sepolia
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 3441005,
                }));
                setFillPol(true);
              }}
            >
              <img
                src={manta}
                className="absolute h-[40px] w-[40px] top-3 left-3"
                alt="manta-pacific-testnet"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Manta Pacific Testnet
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 919,
                }));
                setFillPol(true);
              }}
            >
              <img
                src={mode}
                className="absolute h-[40px] w-[40px] top-3 left-3 rounded-full"
                alt="mode-sepolia"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Mode Sepolia
              </p>
            </button>
            <button
              className="relative bg-black px-4 py-2 w-[148px] sm:w-[190px] border-[1px] border-transparent rounded-[20px] h-[106px] text-white z-10 hover:border-purple-500 focus:ring focus:ring-purple-500"
              onClick={() => {
                setInputVal((prevInputVal: any) => ({
                  ...prevInputVal,
                  chain: 64165,
                }));
                setFillPol(true);
              }}
            >
              <img
                src={ftm}
                className="absolute h-[40px] w-[40px] top-3 left-3 rounded-full"
                alt="sonic-testnet"
              />
              <p className="absolute bottom-3 left-4 text-[14px] font-[600]">
                Sonic Testnet
              </p>
            </button>
          </div>
        </div>

        <div className="w-full flex flex-col sm:flex-row justify-between gap-3 sm:gap-5">
          <div className="Card w-full sm:w-[103px] h-[45px] px-6 py-2 rounded-[60px] border border-zinc-500 justify-center items-center gap-2 inline-flex flex-shrink-0">
            <button
              onClick={handlePrevClick}
              className="Back border-violet-400 text-violet-400 text-base font-semibold flex-shrink-0"
            >
              ← Back
            </button>
          </div>
          <button
            disabled={inputVal.sale_version === 0 || inputVal.chain === 0}
            className={`Button relative sm:left-0 w-full sm:w-[280px] h-[45px] px-8 py-[13px] mt-2 sm:mt-0 bg-gradient-to-r from-[#C25FFF] to-[#3D29D0] drop-shadow-[8_-2px_4px_rgba(0, 0, 0, 0.25) z-10 ${inputVal.sale_version === 0 || inputVal.chain === 0 ? 'opacity-50' : 'opacity-100'} rounded-[20px] shadow justify-center items-center gap-2 flex `}
            onClick={() => {
              handleNextClick();
              handleSubmit();
            }}
          >
            <div className="Next text-white text-base font-semibold">Next</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step2;
